<template>
  <div class="container ">
    <br class="blue_line">
    <br class="blue_line">
    <div class="border-1">


     <div class="flex ">
       <img src="../../assets/im/Path 12.png" alt="">
        <div>
          <h2>
            <span>
            Upskill's
            </span>

            <span>
             ISA program
            </span>
             could prove to be a powerful solution:

          </h2>
            <p>
              Industry partners can co-create the learning program based on their hard-earned experiences and committed talents can stay assured of guaranteed placements in the fields they are passionate about! We are very excited about our collaboration with UPSKILL team. Eagerly looking forward to meeting the first batch from where we promise to take, at least, four Deep Learning engineers!
            </p>
        </div>
       <img src="../../assets/im/Path 13.png" alt="">

     </div>
     <div class="flex-sec">
       <img src="../../assets/im/ca64-400o400o2-dc-5e69-48d2-aec5-2256dcd7f3f6.af6ca0a0-edc7-44c5-a8d6-711973d2a724@2x.png" alt="">
       <div>
         <h3>Mohammad oli ahad</h3>
         <h5>Founder and CEO </h5>
         <p>Intelligent Machines Limited</p>
       </div>
     </div>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
h2  {
  text-align: left;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  color: #0047C2;
  padding: 0 65px 0px 65px;
}
h2 span {
  text-align: left;
  font-family: 'Open Sans';
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
  color: #0047C2;

}
p {
  text-align: left;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #3C4663;
  padding: 0 45px 0px 65px;
}
.flex-sec{
  display: flex;
  align-items: center;
  padding-top: 50px;
  padding-left: 150px;
}
.flex-sec img{
  max-width: 150px;
  max-height: 150px;
  padding-right: 45px;
}
.flex-sec h3{
   text-align: left;
  font-family: 'Open Sans';
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
  color: #0047C2;
  letter-spacing: -1.2px;
  text-transform: capitalize;
}

.flex-sec h5{
text-align: left;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #84888B;

}
.flex-sec p{
text-align: left;
  font-family: 'Open Sans';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #84888B;
  padding: 0;

}
.border-1{
  max-width: 1320px;
  margin: 0 auto;
  padding: 100px 0;
  border-top: 2px solid #0047C2;
  border-bottom: 2px solid #0047C2;

}
@media only screen and (max-width: 600px) {
.flex{
  display: flex;
  flex-direction: column;

}
.flex img:first-child{
 max-width: 45px;
 padding-bottom: 35px;

 }
.flex img{
 max-width: 45px;
 padding-top: 15px;

 }

.flex-sec{
  display: flex;
  flex-direction: column;
  align-items: center;
    padding-top: 50px;
    padding-left: 0px;
}
.flex-sec img{
  padding-bottom: 25px;
  padding-right: 0;
}
.flex-sec h3{
   text-align: center;
}

.flex-sec h5{
text-align: center;

}
.flex-sec p{
text-align: center;

}
h2  {
  text-align: center;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  color: #0047C2;
  padding: 0 25px 0px 25px;
}
h2 span {
  text-align: left;
  font-family: 'Open Sans';
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
  color: #0047C2;

}
p {
  text-align: justify;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #3C4663;
  padding: 0 25px 0px 25px;
}
.border-1{
  padding: 50px 0;
}
}


</style>